<template>
  <div class="baseinput">
    <div class="baseinput__fillin">
      <label>{{ labelText }}</label>
      <b-form-input
        :type="type"
        :value="value"
        :placeholder="placeholder"
        :disabled="disabled"
        :state="validateState(name)"
        :name="name"
        :data-vv-name="name"
        v-validate="validation"
        trim
        @input="$emit('input', $event)"
      ></b-form-input>
      <slot name="baseinput-addition"></slot>
    </div>
    <p v-if="veeErrors.has(name)" class="form-error-messgae">
      {{ veeErrors.first(name) }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'BaseInput',
  props: {
    value: {
      type: [String, Number],
      required: false
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: {
      type: String,
      default: null
    },
    labelText: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: ''
    },
    validation: {
      type: String,
      default: ''
    }
  },
  methods: {
    validateState(ref) {
      if (
        !this.validation.includes('required') &&
        (this.value === null || !this.value.length)
      ) {
        return null;
      }
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    }
  }
};
</script>

<style lang="scss" scoped>
.baseinput {
  &__fillin {
    display: flex;
    align-items: center;
    flex-grow: 1;
  }
  label {
    flex: 0 0 80px;
    margin-bottom: 0;
  }
  input {
    width: 100%;
    font-size: 13px;
  }
}

.widerlabel {
  label {
    flex: 0 0 100px;
  }
}
</style>
